import { ca } from '@cian/analytics';

export function trackFullscreenGalleryShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Show_sopr',
    label: 'fullPhoto',
  });
}

export function trackPhotoSave() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Save_sopr',
    label: 'photo',
  });
}
